import { render, staticRenderFns } from "./creategroup.vue?vue&type=template&id=6d9d54bc&scoped=true&"
import script from "./creategroup.vue?vue&type=script&lang=js&"
export * from "./creategroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d54bc",
  null
  
)

export default component.exports